import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import * as moment from 'moment';
import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CircularsService } from 'src/app/modules/retailer/services/circulars.service';

@Component({
  selector: 'app-create-circular',
  templateUrl: './create-circular.component.html',
  styleUrls: ['./create-circular.component.scss']
})
export class CreateCircularComponent implements OnInit {
  public pageMode: string; // add/edit

  public loginData: any;
  public editCircularDetails: any;

  public stores: any = [];
  public storeSelectionSettings: IDropdownSettings;
  public storeSelectionDisabled: boolean;
  public selectedStores: any = [];

  public calendarConfig = { adaptivePosition: true, dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers: false };
  public calendarMinDate: Date;

  public circularStores: any = [];
  public circularName: string;
  public circularDateRange: any;
  public circularImageFilesSelected: any = [];
  public circularImageFilesDropzone: File[] = [];
  public circularImageSelecting = false;
  public circularPagetoRemove: any;

  public savingCircular: boolean = false;
  public circularSaveConfirmModal: BsModalRef;
  public isDeleteCircular: boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _modalService: BsModalService,
    private _utilService: UtilService,
    private _circularsService: CircularsService
  ) {
    this.editCircularDetails = this._router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    // Calendar setings with timezone
    this.calendarMinDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'));

    // Store selection settings
    this.storeSelectionSettings = {
      singleSelection: false,
      idField: 'store_id',
      textField: 'store_name',
      selectAllText: 'Select All Stores',
      unSelectAllText: 'UnSelect All Stores',
      //itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false
    };

    if (this.editCircularDetails) { // Edit circular
      this.pageMode = 'edit';

      // List selected store
      let allStores = await this._utilService.getStorageData('R_RETAILERS');
      this.stores = _.filter(allStores, obj => obj.store_id == this.editCircularDetails.store_id);
      this.storeSelectionDisabled = true; // Store selection disabled
      this.selectedStores = this.stores;

      this.circularStores = this.stores;
      this.circularName = this.editCircularDetails.circular.name;
      this.circularDateRange = [new Date(moment(this.editCircularDetails.circular.start_date).utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')), new Date(moment(this.editCircularDetails.circular.end_date).utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))];

      for(let i=0; i<=this.editCircularDetails.circular.images.length - 1; i++) {
        this.circularImageFilesSelected.push({
          id: this.editCircularDetails.circular.images[i].image_id,
          file: null,
          file_base64: null,
          file_s3: this.editCircularDetails.circular.images[i].name
        })
      }
    } else { // Add circular
      this.pageMode = 'add';

      // List all stores
      this.stores = await this._utilService.getStorageData('R_RETAILERS');
      this.storeSelectionDisabled = false; // Store selection enabled
      this.selectedStores = [];

      this.circularStores = [];
      this.circularName = null;
      this.circularDateRange = [new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).add(7, 'days').format('YYYY-MM-DD HH:mm'))];
      this.circularImageFilesSelected = [];
    }
  }

  // On Store select
  onStoreSelect(store: any) {
    this.circularStores.push(store);
  }

  // On Store deselect
  onStoreDeSelect(store: any) {
    this.circularStores = _.filter(this.circularStores, obj => obj.store_id != store.store_id);
  }

  // On calendar value change
  onCalendarValueChange(event: any) {
    // Update circular date
    this.circularDateRange = event;
  }

  // Circular image select
  circularImageSelect(event) {
    // Remove files if exists
    if(this.circularImageFilesDropzone && this.circularImageFilesDropzone.length >=1) {
      this.circularImageRemove(this.circularImageFilesDropzone[0]);
    }

    this.circularImageSelecting = true;
    for (let i=0; i<=event.addedFiles.length - 1; i++) {
      this._utilService.imageFiletoBase64(event.addedFiles[i], 1024).then(fileContents => {
        let fileIndex = this.circularImageFilesSelected.length + 1;

        this.circularImageFilesSelected.push({
          id: fileIndex,
          file: event.addedFiles[i],
          file_base64: fileContents,
          file_s3: null
        }); // Add image to uploaded list
        this.circularImageSelecting = false;
      }, error => {
        this.circularImageSelecting = false;
        this._utilService.showToast(error, '', 'warning', {});
      });
    }
  }

  // Circular image remove
  circularImageRemove(event) {
    this.circularImageFilesDropzone.splice(this.circularImageFilesDropzone.indexOf(event), 1);
  }

  // Circular page remove confirm
  circularPageRemoveConfirm(image) {
    this.circularPagetoRemove = image;
  }

  // Circular page remove
  circularPageRemove() {
    this.circularImageFilesSelected.splice(this.circularImageFilesSelected.indexOf(this.circularPagetoRemove), 1);
    this.circularPagetoRemove = null;
  }

  // On save circular click
  onSaveCircularClick(template: TemplateRef<any>) {
    // Validations
    if(this.circularStores.length == 0) { // Stores
      this._utilService.showToast('Please select stores', '', 'warning', {});
      return false;
    }

    if(!this.circularName) { // Name
      this._utilService.showToast('Please enter circular name', '', 'warning', {});
      return false;
    }

    if(!this.circularDateRange) { // Date range
      this._utilService.showToast('Please select circular date range', '', 'warning', {});
      return false;
    }

    if(this.circularImageFilesSelected.length == 0) { // Images
      this._utilService.showToast('Please select circular image file', '', 'warning', {});
      return false;
    }

    this.circularSaveConfirmModal = this._modalService.show(template, {class: 'modal-sm', ignoreBackdropClick: true});
  }

  // On delete circular click
  onDeleteCircularClick(template: TemplateRef<any>) {
    if (this.pageMode == 'edit') {
      this.isDeleteCircular = true; // Enable delete mode
      this.circularSaveConfirmModal = this._modalService.show(template, {class: 'modal-sm', ignoreBackdropClick: true});
    }
  }

  // Create circular
  async createCircular() {
    this.savingCircular = true;

    // Upload images to S3
    //let imageFolder: string = this.loginData.user_details.provider_type + this.loginData.user_details.provider_id + '/' + environment.s3_folder_circulars + '/';
    let imageFolder: string = environment.cloud_storage_folder_prefix + '/' + this.loginData.user_details.provider_type + this.loginData.user_details.provider_id + '/' + environment.cloud_storage_folder_circulars;
    for(let i=0; i<=this.circularImageFilesSelected.length - 1; i++) {
      if (this.circularImageFilesSelected[i].file) { // Upload only new files
        /*let imageUploadResponse: any = await this._utilService.s3Base64Upload(this.circularImageFilesSelected[i].file, this.circularImageFilesSelected[i].file_base64, environment.s3_bucket, imageFolder);

        if(imageUploadResponse.status == true){ // Upload success
          this.circularImageFilesSelected[i].file_s3 = imageUploadResponse.location;
        } else { // Upload Error
          this._utilService.showToast('Error while uploading image', '', 'error', {});
          this.savingCircular = false;
          break;
        }*/

        // Upload file to cloud storage
        let uploadFileBody: any = {
          bucket: environment.cloud_storage_bucket,
          folder: imageFolder,
          fileType: this.circularImageFilesSelected[i].file.type,
          base64Data: this.circularImageFilesSelected[i].file_base64
        }
        
        this._utilService.uploadFile(this.loginData.token, uploadFileBody).subscribe(async uploadFileResponse => {
          if (uploadFileResponse.status === true) { // Success
            this.circularImageFilesSelected[i].file_s3 = uploadFileResponse.file_name;

            if (this.pageMode == 'add') {
              this.addCircular();
            } else if (this.pageMode == 'edit') {
              this.editCircular();
            }
          } else {
            this._utilService.showToast('Error while uploading image', '', 'error', {});
            this.savingCircular = false;
          }
        }, error => { // Error from createCircular
          this.savingCircular = false;
        });
      }
    }
  }

  // Add circular
  addCircular() {
    try {
      // Get store details
      let selected_store_ids: any = _.map(this.circularStores, 'store_id');

      // Get image details
      let image_list: any = [];
      for(let i=0; i<=this.circularImageFilesSelected.length - 1; i++) {
        image_list.push({
          page: i+1,
          name: this.circularImageFilesSelected[i].file_s3
        });
      }

      let createCircularBody: any = {
        retailer_id: this.loginData.user_details.provider_id,
        store_id: selected_store_ids,
        type: 'image', // Only image now
        name: this.circularName.replace("'","''''"),
        start_date: moment(this.circularDateRange[0]).format('YYYY-MM-DD') + ' 00:00:00.000', // 12 AM
        end_date: moment(this.circularDateRange[1]).format('YYYY-MM-DD') + ' 23:59:59.000', // 11:59 PM
        images: image_list
      }

      this._circularsService.createCircular(this.loginData.token, createCircularBody).subscribe(async createCircularResponse => {
        this.savingCircular = false;

        if (createCircularResponse.status === true) { // Success
          this.hideCircularSaveConfirmModal(); // Close modal

          this._utilService.showToast('Circular created successfully', '', 'success', {});
          this._router.navigate(['/retailer/circulars']); // Go to circular list
        } else {
          this._utilService.showToast(createCircularResponse.message, '', 'error', {});
        }
      }, error => { // Error from createCircular
        this.savingCircular = false;
      });
    } catch (err) {
      this.savingCircular = false;
      this._utilService.showToast('Error while creating circular', '', 'error', {});
    }
  }

  // Edit circular
  editCircular() {
    try {
      // Get image details
      let image_list: any = [];
      for(let i=0; i<=this.circularImageFilesSelected.length - 1; i++) {
        image_list.push({
          page: i+1,
          name: this.circularImageFilesSelected[i].file_s3
        });
      }

      let updateCircularBody: any = {
        circular_id: this.editCircularDetails.circular.circular_id,
        retailer_id: this.loginData.user_details.provider_id,
        store_id: this.editCircularDetails.store_id,
        name: this.circularName.replace("'","''''"),
        start_date: moment(this.circularDateRange[0]).format('YYYY-MM-DD') + ' 00:00:00.000', // 12 AM
        end_date: moment(this.circularDateRange[1]).format('YYYY-MM-DD') + ' 23:59:59.000', // 11:59 PM
        images: image_list
      }
      
      this._circularsService.updateCircular(this.loginData.token, updateCircularBody).subscribe(async updateCircularResponse => {
        this.savingCircular = false;

        if (updateCircularResponse.status === true) { // Success
          this.hideCircularSaveConfirmModal(); // Close modal

          this._utilService.showToast('Circular edited successfully', '', 'success', {});
          this._router.navigate(['/retailer/circulars']); // Go to circular list
        } else {
          this._utilService.showToast(updateCircularResponse.message, '', 'error', {});
        }
      }, error => { // Error from updateCircular
        this.savingCircular = false;
      });
    } catch (err) {
      this.savingCircular = false;
      this._utilService.showToast('Error while editing circular', '', 'error', {});
    }
  }

  // Delete circular
  async deleteCircular() {
    this.savingCircular = true;

    let deleteCircularBody: any = {
      circular_id: this.editCircularDetails.circular.circular_id,
      retailer_id: this.loginData.user_details.provider_id,
      store_id: this.editCircularDetails.store_id
    }

    this._circularsService.deleteCircular(this.loginData.token, deleteCircularBody).subscribe(async deleteCircularResponse => {
      this.savingCircular = false;

      if (deleteCircularResponse.status === true) { // Success
        this.hideCircularSaveConfirmModal(); // Close modal

        this._utilService.showToast('Circular deleted successfully', '', 'success', {});
        this._router.navigate(['/retailer/circulars']); // Go to circular list
      } else {
        this._utilService.showToast(deleteCircularResponse.message, '', 'error', {});
      }
    }, error => { // Error from deleteCircular
      this.savingCircular = false;
    });
  }

  // Hide circular save confirm modal
  hideCircularSaveConfirmModal(): void {
    this.isDeleteCircular = false; // Disable delete mode
    this.circularSaveConfirmModal.hide();
  }

}
